import * as React from 'react'
import {Link} from "gatsby"

const Overlay = () => {
    return (
        <div>
            <div className="pop-up-media">
                <figure>
                    <img alt="" className="ort-img" src={"/images/Ermershausen/teaser-ermershausen.jpg"}/>
                    <figcaption>
                        Quelle: Pressebüro Cama, Foto: Gerhard Schmidt
                    </figcaption>
                </figure>
            </div>
            <div className="pop-up-body">
                <p className='ort-header'>
                    1978: Ermershausen </p>
                <p className="ort-subheader">
                    <i>„Beharrlichkeit und Einigkeit brachten den Erfolg.“</i>
                </p>
                <Link to="/orte/ermershausen/" className='ort-text icon-arrow-right load-infobox'>
                    Mehr erfahren
                </Link>
            </div>

        </div>
    )
}

export default Overlay

